export const VN_SET_CONFIGURATION = 'VN_SET_CONFIGURATION'
export const VN_SET_GLOBAL_CONFIGURATION = 'VN_SET_GLOBAL_CONFIGURATION'
